import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import SelectInput from '@/common/components/SelectInput';
import { ORDER_STATUSES } from '@/common/constants/statuses';
import { Selects, Wrapper } from './styles';
import useQueueMigrate from './useQueueMigrate';

export default function QueueMigrate() {
	const hook = useQueueMigrate();

	return (
		<>
			{hook.isLoading && <Loading />}
			<Wrapper>
				<h3>Migrate Queue</h3>
				<span style={{ color: Colors.red }}>
					"First dequeue after" of a target queue will be set to 1.
				</span>
				<Selects>
					<SelectInput
						name='Queue from'
						options={hook.queuesOptions}
						setSelected={hook.setQueueFrom}
						selected={hook.queueFrom}
						width={100}
						showLabel={false}
						required
					/>
					<i
						className='fa-solid fa-arrow-right'
						style={{
							fontSize: '20px',
							color: Colors.darkBlue,
						}}
					/>
					<SelectInput
						name='Queue to'
						options={hook.queuesOptions}
						setSelected={hook.setQueueTo}
						selected={hook.queueTo}
						width={100}
						showLabel={false}
						required
					/>
				</Selects>
				<SelectInput
					name='Statuses'
					options={ORDER_STATUSES}
					setSelected={hook.setStatuses}
					selected={hook.statuses}
					width={171}
					color={Colors.darkBlue}
					multiple
					required
				/>
				<Input
					inputRef={hook.dateFromRef}
					name='From date'
					type='date'
					color={Colors.darkBlue}
					width={171}
					requiredSign
				/>
				<Input
					inputRef={hook.maxCallAttemptsRef}
					name='Max call attempts'
					type='number'
					color={Colors.darkBlue}
					width={171}
					requiredSign
				/>
				<ActionButton
					onClick={() => hook.handleConfirm()}
					defaultText='Confirm'
					color={Colors.darkBlue}
					style={{ alignSelf: 'flex-end', marginTop: '1rem' }}
				/>
			</Wrapper>
		</>
	);
}
